import React, { useRef, useState, Component } from "react";


import "./Slideshow.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Partners } from "../Misc/Partners";


function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div
      className={className + " prevArrow"}
      style={{ display: "block" }}
      onClick={onClick}
    ></div>
  );
}

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <i class="las la-angle-right"></i>
    </div>
  );
}


export default function Slideshow() {
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        }
      ]
    };
    return (
      <Slider {...settings}>
        {Partners.map((item, index) => {
          return (
            <div className="slideItem" key={index}>
              <div className="partner-logo-container">
                <a href={item.externalURL}>
                  <img
                    className="partner-logo"
                    src={require(`../../../images/${item.logoURL}`)}
                    alt={item.name + " logo"}
                  />
                </a>
              </div>
            </div>
          );
        })}
      </Slider>
    );
}